import { Component, Input, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';

@Component({
    selector: 'fc-dropdown',
    templateUrl: './fc-dropdown.component.html',
    styleUrls: ['./fc-dropdown.component.less'],
    standalone: false
})
export class FcDropdownComponent {
    @Input() items: DropdownItem[];
    @Input() title: string;
    @Input() disabled: boolean;
    @Input() selectedItem: DropdownItem;
    @Input() e2eHook: string;
    @Input() showIcon = false;

    @Output() onSelect = new EventEmitter<DropdownItem>();

    public displayItems = false;

    constructor(private element: ElementRef) {}

    @HostListener('document:click', ['$event.target'])
    public onClick(targetElement: HTMLElement): void {
        if (this.element.nativeElement.contains(targetElement)) {
            return;
        }
        this.displayItems = false;
    }

    public selectItem(item: DropdownItem) {
        if (this.disabled) {
            return;
        }
        this.displayItems = false;
        this.onSelect.emit(item);
    }

    public toggleItems() {
        if (this.disabled) {
            return;
        }
        this.displayItems = !this.displayItems;
    }

    public isSelected(itemText: string): boolean {
        if (this.selectedItem) {
            return this.selectedItem.text === itemText;
        }
    }
}

interface Item<T = any> {
    text: string;
    value: T;
}

interface DropdownItem<T = any> extends Item<T> {
    icon?: Icon;
}

enum Icon {
    PAUSED_CIRCLE = 'pause-circle'
}
